var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h1',{staticClass:"title"},[_c('transition',{attrs:{"appear":""}},[_c('LoadingIndicator',{attrs:{"size":"huge"}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }